// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3AKzn","cell":"ColumnAccessor_cell__Pf_Bt","firstCellAccent":"ColumnAccessor_firstCellAccent__18S99"};